import { Card, Row, Col, Typography, Divider, Button, Space, Collapse, Spin } from "antd";
import { ScheduleOutlined, TagsOutlined, CopyOutlined, TableOutlined, WalletOutlined, EditOutlined, EyeOutlined, DownloadOutlined, DeleteOutlined, ArrowRightOutlined, RightOutlined, DownOutlined, UserOutlined } from "@ant-design/icons";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import "../../assets/dist/NewApplication/ApplicantPreview.css";
import { useEffect, useState } from "react";
import { DollarOutlined } from "@ant-design/icons";
import _NewapplicationService from "../../modules/NewapplicationService";
import { useHistory } from "react-router-dom";
import { routes } from "../../routes/Routes";
import moment from "moment";
import _commonService from "../../modules/commonService";
import { ScreenNameDashboard } from "../../constants/DataConstants";
import BalanceSheetQuestionnaireDashboard from "../BankerUI/BalanceSheetQuestionnaireDashboard";
import ReviewCommentByApplicationIdAndSection from "./ReviewCommentByApplicationIdAndSection";
import "./Dashboard.scss";
const { Title, Text } = Typography;
const FinancialStatementTab = ({ activeKey }) => {
  const [incomeSourceDetails, setIncomeSourceDetails] = useState({});
  const [expensesDetails, setExpensesDetails] = useState({});
  const [cashShortTermInvestmentDetails, setCashShortTermInvestmentDetails] = useState([]);
  const ApplicationObjId = localStorage.getItem("ApplicationObjId");
  const [dataLoadedCashShortTerm, setDataLoadedCashShortTerm] = useState(false);
  const [dataLoadedStockAndBond, setDataLoadedStockAndBond] = useState(false);
  const [dataLoadedCashValue, setDataLoadedCashValue] = useState(false);
  const [dataLoadedunListedStocks, setDataLoadedunListedStocks] = useState(false);
  const [dataLoadedAccountNotesReceivable, setDataLoadedAccountNotesReceivable] = useState(false);
  const [dataLoadedownPersonalResidence, setDataLoadedownPersonalResidence] = useState(false);
  const [dataLoadedVestedIntrestPension, setDataLoadedVestedIntrestPension] = useState(false);
  const [dataLoadedreInvestment, setDataLoadedreInvestment] = useState(false);
  const [dataLoadedLimitedPartenership, setDataLoadedLimitedPartenership] = useState(false);
  const [dataLoadednotesPayableBankSecured, setDataLoadednotesPayableBankSecured] = useState(false);
  const [dataLoadednotesPayableBankUnSecured, setDataLoadednotesPayableBankUnSecured] = useState(false);
  const [dataLoadednotesPayableOther, setDataLoadednotesPayableOther] = useState(false);
  const [dataLoadedAccountPayable, setDataLoadedAccountPayable] = useState(false);
  const [dataLoadedcreditCardBalance, setDataLoadedcreditCardBalance] = useState(false);
  const [dataLoadedMortgagesDueWithInOne, setDataLoadedMortgagesDueWithInOne] = useState(false);
  const [dataLoadedMortgagesDueBeyond, setDataLoadedMortgagesDueBeyond] = useState(false);
  const [listedStockAndBondsDetails, setListedStockAndBondsDetails] = useState([]);
  const [accountsandNotesReceivableDetails, setccountsandNotesReceivableDetails] = useState([]);
  const [cashValueLifeInsuranceDetails, setCashValueLifeInsurance] = useState([]);
  const [financialStatementDataDetails, setfinancialStatementData] = useState([]);
  const [ownPersonalResidenceDetails, setOwnPersonalResidenceDetails] = useState([]);
  const [vestedIntrestPensionDetails, setVestedIntrestPensionDetails] = useState([]);
  const [unListedStocksDetails, setunListedStocksDetails] = useState([]);
  const [reInvestmentDetails, setreInvestmentDetails] = useState([]);
  const [generalAndLimitedPartenershipDetails, setGeneralAndLimitedPartenershipDetails] = useState([]);
  const [notesPayableBankSecuredDetails, setNotesPayableBankSecuredDetails] = useState([]);
  const [notesPayableBankUnSecuredDetails, setNotesPayableBankUnSecuredDetails] = useState([]);
  const [accountPayableDetails, setAccountPayableDetails] = useState([]);
  const [notesPayableOtherDetails, setNotesPayableOtherDetails] = useState([]);
  const [creditCardBalanceDetails, setCreditCardBalanceDetails] = useState([]);
  const [mortgagesDueWithInOneDetails, setMortgagesDueWithInOneDetails] = useState([]);
  const [mortgagesDueBeyondOneDetails, setMortgagesDueBeyondOneDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    if (activeKey && activeKey == "4") {
      getIncomeSourceDetailsByID();
      getExpensesDetailsByID();
      getFinancialStatementData();
    }
  }, [activeKey]);

  const getIncomeSourceDetailsByID = async () => {
    try {
      setLoading(true);
      const res = await _NewapplicationService.getIncomeSourceByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setIncomeSourceDetails(resObj[0]);
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };
  const getExpensesDetailsByID = async () => {
    try {
      setLoading(true);
      const res = await _NewapplicationService.getExpensesByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setExpensesDetails(resObj[0]);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };
  const getCashShortTermInvestmentDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getCashShortTermInvestmentsByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setCashShortTermInvestmentDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getListedStockAndBondsDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getStockBondGovSecurityByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setListedStockAndBondsDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getFinancialStatementData = async () => {
    try {
      setLoading(true);
      const res = await _NewapplicationService.getFinancialStatementData(ApplicationObjId, ScreenNameDashboard);
      if (res.data) {
        let resObj = res?.data.Obj;
        setfinancialStatementData(resObj);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.error("Error fetching assets", err);
    }
  };

  const getAccountsAndNotesReceivableDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getAccountNoteReceivableByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setccountsandNotesReceivableDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getCashValueLifeInsuranceDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getCashValueLifeInsuranceByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setCashValueLifeInsurance(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getOwnPersonalResidenceDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getOwnPersonalResidenceByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setOwnPersonalResidenceDetails(resObj);

      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getVestedIntrestPensionDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getVestedIntrestPensionByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setVestedIntrestPensionDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getUnListedStocksDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getUnListedStocksByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setunListedStocksDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getReInvestmentDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getInvestmentByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setreInvestmentDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getGeneralAndLimitedPartenershipDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getGeneralAndLimitedPartenershipByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setGeneralAndLimitedPartenershipDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getNotesPayableBankSecuredDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getNotesPayableBankSecuredByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setNotesPayableBankSecuredDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getNotesPayableBankUnSecuredDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getNotesPayableBankUnSecuredByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setNotesPayableBankUnSecuredDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getAccountsPayableDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getAccountsPayableByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setAccountPayableDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };

  const getNotesPayableOtherDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getNotesPayableOtherByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setNotesPayableOtherDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getCreditCardBalanceDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getCreditCardBalanceByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setCreditCardBalanceDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getMortagagesDueWithInOneDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getMortgageDueWithinByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setMortgagesDueWithInOneDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };
  const getMortagagesDueBeyondOneDetailsByID = async () => {
    try {
      const res = await _NewapplicationService.getMortgageDueBeyondByApplicationID(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setMortgagesDueBeyondOneDetails(resObj);
      }
    } catch (err) {
      console.error("Error fetching assets", err);
    }
  };

  const onIncomeSourcesEditClick = () => {
    history.push({
      pathname: routes.incomeSources.path,
      state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
    });
  }
  const onExpensesEditClick = () => {
    history.push({
      pathname: routes.expenses.path,
      state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
    });
  }
  const onBalanceSheetAssetsEditClick = () => {
    history.push({
      pathname: routes.balanceSheetAssets.path,
      state: { applicationObjId: ApplicationObjId, isFromDashboard: true, activeKey },
    });
  }
  const handleCollapseCashShortTermInvestmentChange = (key) => {
    if (key === "1" && !dataLoadedCashShortTerm) {
      getCashShortTermInvestmentDetailsByID();
      setDataLoadedCashShortTerm(true);
    }
  }
  const handleCollapseListedStockAndBondChange = (key) => {
    if (key === "2" && !dataLoadedStockAndBond) {
      getListedStockAndBondsDetailsByID();
      setDataLoadedStockAndBond(true);
    }
  }
  const handleCollapseChangeAccountNotesReceivable = (key) => {
    if (key === "3" && !dataLoadedAccountNotesReceivable) {
      getAccountsAndNotesReceivableDetailsByID();
      setDataLoadedAccountNotesReceivable(true);
    }
  }
  const handleCollapseCashValueLifeInsurance = (key) => {
    if (key === "4" && !dataLoadedCashValue) {
      getCashValueLifeInsuranceDetailsByID();
      setDataLoadedCashValue(true);
    }
  }
  const onBalanceSheetTotalAssetsEditClick = () => {
    history.push({
      pathname: routes.balanceSheetTotalAssets.path,
      state: { applicationObjId: ApplicationObjId, isFromDashboard: true, activeKey },
    });
  }
  const handleCollapseOwnPersonalResidence = (key) => {
    if (key === "5" && !dataLoadedownPersonalResidence) {
      getOwnPersonalResidenceDetailsByID();
      setDataLoadedownPersonalResidence(true);
    }
  }
  const handleCollapseestedIntrestPension = (key) => {
    if (key === "6" && !dataLoadedVestedIntrestPension) {
      getVestedIntrestPensionDetailsByID();
      setDataLoadedVestedIntrestPension(true);
    }
  }
  const handleCollapUnListedStocks = (key) => {
    if (key === "7" && !dataLoadedunListedStocks) {
      getUnListedStocksDetailsByID();
      setDataLoadedunListedStocks(true);
    }
  }
  const handleCollapReInvestment = (key) => {
    if (key === "8" && !dataLoadedreInvestment) {
      getReInvestmentDetailsByID();
      setDataLoadedreInvestment(true);
    }
  }
  const handleCollapgeneralAndLimitedPartenership = (key) => {
    if (key === "9" && !dataLoadedLimitedPartenership) {
      getGeneralAndLimitedPartenershipDetailsByID();
      setDataLoadedLimitedPartenership(true);
    }
  }
  const handleCollapseNotesPayableBankSecured = (key) => {
    if (key === "10" && !dataLoadednotesPayableBankSecured) {
      getNotesPayableBankSecuredDetailsByID();
      setDataLoadednotesPayableBankSecured(true);
    }
  }
  const handleCollapseNotesPayableBankUnSecured = (key) => {
    if (key === "11" && !dataLoadednotesPayableBankUnSecured) {
      getNotesPayableBankUnSecuredDetailsByID();
      setDataLoadednotesPayableBankUnSecured(true);
    }
  }
  const handleCollapseAccountsPayableChange = (key) => {
    if (key === "12" && !dataLoadedAccountPayable) {
      getAccountsPayableDetailsByID();
      setDataLoadedAccountPayable(true);
    }
  }
  const handleCollapseChangeNotesPayableOther = (key) => {
    if (key === "13" && !dataLoadednotesPayableOther) {
      getNotesPayableOtherDetailsByID();
      setDataLoadednotesPayableOther(true);
    }
  }

  const handleCollapseChangeCreditCardsBalance = (key) => {
    if (key === "14" && !dataLoadedcreditCardBalance) {
      getCreditCardBalanceDetailsByID();
      setDataLoadedcreditCardBalance(true);
    }
  }
  const handleCollapseChangeMortagagesDueWihtinOne = (key) => {
    if (key === "15" && !dataLoadedMortgagesDueWithInOne) {
      getMortagagesDueWithInOneDetailsByID();
      setDataLoadedMortgagesDueWithInOne(true);
    }
  }
  const handleCollapseChangeMortagagesDueBeyondOne = (key) => {
    if (key === "16" && !dataLoadedMortgagesDueBeyond) {
      getMortagagesDueBeyondOneDetailsByID();
      setDataLoadedMortgagesDueBeyond(true);
    }
  }
  const onBalanceSheetTotalLiabilitiesAssetsEditClick = () => {
    history.push({
      pathname: routes.balanceSheetTotalLiabilities.path,
      state: { applicationObjId: ApplicationObjId, isFromDashboard: true, activeKey },
    });
  }
  return (
    <Spin spinning={loading}>

      <Card
        title={
          <Row justify="space-between" align="middle" className="balance-heading">
            <Text strong>
              <span role="img" aria-label="user" style={{ marginRight: 8 }}><CopyOutlined /> </span>
              Income Sources
            </Text>
            <EditOutlined onClick={onIncomeSourcesEditClick} style={{ color: "#595959", cursor: "pointer" }} />
          </Row>
        }
        
        className="mb30 card-section incomeSourceCard "
      >
        <div>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Text type="secondary">Salary (Gross)</Text>
            <div className="b-bottm">{incomeSourceDetails && incomeSourceDetails.GrossSalary ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.GrossSalary)}` : "N/A"}</div>
          </Col>
          <Col span={8}>
            <Text type="secondary">Bonus and Commissions</Text>
            <div className="b-bottm">{incomeSourceDetails && incomeSourceDetails.BonusCommission ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.BonusCommission)}` : "N/A"}</div>
          </Col>
          <Col span={8}>
            <Text type="secondary">Dividends</Text>
            <div className="b-bottm">{incomeSourceDetails && incomeSourceDetails.Devidend ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.Devidend)}` : "N/A"}</div>
          </Col>
          <Col span={8}>
            <Text type="secondary">Interest</Text>
            <div className="b-bottm">{incomeSourceDetails && incomeSourceDetails.Interest ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.Interest)}` : "N/A"}</div>
          </Col>
          <Col span={8}>
            <Text type="secondary">Rental Income (Net)</Text>
            <div className="b-bottm">{incomeSourceDetails && incomeSourceDetails.RentalIncome ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.RentalIncome)}` : "N/A"}</div>
          </Col>
          <Col span={8}>
            <Text type="secondary">General Limited Partnership Income (Net)</Text>
            <div className="b-bottm">{incomeSourceDetails && incomeSourceDetails.GenLimitedPartnershipIncome ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.GenLimitedPartnershipIncome)}` : "N/A"}</div>
          </Col>
          <Col span={8}>
            <Text type="secondary">Trust Income</Text>
            <div className="b-bottm">{incomeSourceDetails && incomeSourceDetails.TrustIncome ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.TrustIncome)}` : "N/A"}</div>
          </Col>
          <Col span={8}>
            <Text type="secondary">Pension Income</Text>
            <div className="b-bottm">{incomeSourceDetails && incomeSourceDetails.PensionIncome ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.PensionIncome)}` : "N/A"}</div>
          </Col>
          <Col span={8}>
            <Text type="secondary">Other Income</Text>
            <div className="b-bottm">{incomeSourceDetails && incomeSourceDetails.OtherIncome ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.OtherIncome)}` : "N/A"}</div>
          </Col>
          <Col span={8}>
            <Text type="secondary">Total</Text>
            <div className="b-bottm">{incomeSourceDetails && incomeSourceDetails.IncomeSourceTotal ? `$ ${_commonService.formatNumberWithCommas(incomeSourceDetails.IncomeSourceTotal)}` : "N/A"}</div>
          </Col>
        </Row>
        </div>
         <ReviewCommentByApplicationIdAndSection  CommentSectionName="incomesource" />
      </Card>

      <Card
        title={
          <Row justify="space-between" align="middle" className="balance-heading">
            <Text strong>
              <span role="img" aria-label="user" style={{ marginRight: 8 }}><TableOutlined /> </span>
              Expenses
            </Text>
            <EditOutlined onClick={onExpensesEditClick} style={{ color: "#595959", cursor: "pointer" }} />
          </Row>
        }      
        className="mb30 card-section expensesCard "
      >
         <div>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Text type="secondary">Mortgage or Rental Payments (P&I)</Text>
            <div className="b-bottm">{expensesDetails && expensesDetails.MortgageOrRentalPayment ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.MortgageOrRentalPayment)}` : "N/A"}</div>
          </Col>

          <Col span={8}>
            <Text type="secondary">Loan Payments (Excluding Mortgages)</Text>
            <div className="b-bottm">{expensesDetails && expensesDetails.LoanPayment ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.LoanPayment)}` : "N/A"}</div>
          </Col>

          <Col span={8}>
            <Text type="secondary">Property Taxes/Assessments</Text>
            <div className="b-bottm">{expensesDetails && expensesDetails.PropertyTax ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.PropertyTax)}` : "N/A"}</div>
          </Col>

          <Col span={8}>
            <Text type="secondary">Taxes (City, State, Federal)</Text>
            <div className="b-bottm">{expensesDetails && expensesDetails.Taxes ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.Taxes)}` : "N/A"}</div>
          </Col>

          <Col span={8}>
            <Text type="secondary">Insurance Premiums</Text>
            <div className="b-bottm">{expensesDetails && expensesDetails.InsurancePremium ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.InsurancePremium)}` : "N/A"}</div>
          </Col>

          <Col span={8}>
            <Text type="secondary">Alimony, Child Support, Maintenance</Text>
            <div className="b-bottm">{expensesDetails && expensesDetails.Aluminy_ChildSupport_Maintainance ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.Aluminy_ChildSupport_Maintainance)}` : "N/A"}</div>
          </Col>

          <Col span={8}>
            <Text type="secondary">Living Expenses</Text>
            <div className="b-bottm">{expensesDetails && expensesDetails.LivingExpenses ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.LivingExpenses)}` : "N/A"}</div>
          </Col>

          <Col span={8}>
            <Text type="secondary">Other Expense</Text>
            <div className="b-bottm">{expensesDetails && expensesDetails.OtherExpenses ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.OtherExpenses)}` : "N/A"}</div>
          </Col>

          <Col span={8}>
            <Text type="secondary">Total</Text>
            <div className="b-bottm">{expensesDetails && expensesDetails.ExpenseTotal ? `$ ${_commonService.formatNumberWithCommas(expensesDetails.ExpenseTotal)}` : "N/A"}</div>
          </Col>
        </Row>
        </div>
          <ReviewCommentByApplicationIdAndSection  CommentSectionName="expenses" />
      </Card>
      <Card
        title={
          <Row justify="space-between" align="middle" className="balance-heading">
            <Text strong>
              <span role="img" aria-label="user" style={{ marginRight: 8 }}><WalletOutlined /></span>
              Balance Sheet - Assets (Liquid/Marketable Assets)
            </Text>

            <Text className="balance-price" align="middle">
              <span className="b-price">{financialStatementDataDetails.LiquidMarketableAssetsTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.LiquidMarketableAssetsTotal)}`:"N/A"} </span>
              <EditOutlined onClick={onBalanceSheetAssetsEditClick} style={{ color: "#595959", cursor: "pointer" }} />
            </Text>
          </Row>
        }        
        className="mb30 card-section custom-section"
      >
        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseCashShortTermInvestmentChange}
        >
          <CollapsePanel
            key="1"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>Cash & Short-Term Investments</Text>
                </Col>
                <Col>
                  <Text strong>
                    {financialStatementDataDetails?.CashShortTermInvestmentsTotal
                      ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.CashShortTermInvestmentsTotal)}`
                      : "N/A"}
                  </Text>
                </Col>
              </Row>
            }
          >
            {cashShortTermInvestmentDetails?.map((item) => (
              <Card
                key={item.Id}
                size="small"
                type="inner"
              
                className="mb30 card-section custom-section"
              >
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <Text type="secondary">Financial Institution</Text>
                    <div>{item.FinInstitutionalName ? item.FinInstitutionalName : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Account Type</Text>
                    <div>{item.TypeOfAccount ? item.TypeOfAccount : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Owner</Text>
                    <div>{item.Owner ? item.Owner : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Pledged To</Text>
                    <div>{item.PledgeToWhome ? item.PledgeToWhome : " N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Total Amount</Text>
                    <div>{item.Total ? `$${_commonService.formatNumberWithCommas(item.Total)}` : "N/A"}</div>
                  </Col>
                </Row>
              </Card>
            ))}
          </CollapsePanel>
        </Collapse>


        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseListedStockAndBondChange}
        >
          <CollapsePanel
            key="2"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>Listed Stocks and Bonds & Gov't Securities</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails.StockBondGovSecurityTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.StockBondGovSecurityTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {listedStockAndBondsDetails?.map((item) => (
              <Card
                key={item.Id}
                size="small"
                type="inner"
                // style={{ marginBottom: 16, borderRadius: 8 }}
                // bodyStyle={{ padding: 16 }}
                className="mb30 card-section custom-section"
              >
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <Text type="secondary">No. Shares or Par Value of Bonds, Notes, Bills</Text>
                    <div>{item.SharesOrParValueBonds_Notes_Bills ? `$ ${_commonService.formatNumberWithCommas(item.SharesOrParValueBonds_Notes_Bills)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Which Exchange</Text>
                    <div>{item.WhichExchage ? item.WhichExchage : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Description</Text>
                    <div>{item.Description ? item.Description : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Owner</Text>
                    <div>{item.Owner ? item.Owner : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Cost Basis</Text>
                    <div>{item.CoastBasis ? `$ ${_commonService.formatNumberWithCommas(item.CoastBasis)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Market Value</Text>
                    <div>{item.MarketValue ? `$ ${_commonService.formatNumberWithCommas(item.MarketValue)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">If Pledged, to whom?</Text>
                    <div>{item.PledgeToWhome ? item.PledgeToWhome : "N/A"}</div>
                  </Col>
                </Row>
              </Card>
            ))}
          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseChangeAccountNotesReceivable}
        >
          <CollapsePanel
            key="3"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>Accounts and Notes Receivable</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails?.AccountNoteReceivableTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.AccountNoteReceivableTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {accountsandNotesReceivableDetails?.map((item) => (
              <Card
                key={item.Id}
                size="small"
                type="inner"
                // style={{ marginBottom: 16, borderRadius: 8 }}
                // bodyStyle={{ padding: 16 }}
                className="mb30 card-section custom-section"
              >
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <Text type="secondary">Name of Debtor</Text>
                    <div>{item.NameOfDebtor ? item.NameOfDebtor : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Collateral</Text>
                    <div>{item.Collateral ? `$ ${_commonService.formatNumberWithCommas(item.Collateral)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Interest Rate</Text>
                    <div>{item.InterestRate ? `$ ${_commonService.formatNumberWithCommas(item.InterestRate)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Payable</Text>
                    <div>{item.Payble ? `$ ${_commonService.formatNumberWithCommas(item.Payble)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Maturity Date</Text>
                    <div>{item.MaturityDate ? `$ ${_commonService.convertToMMDDYYYY(item.MaturityDate)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Unpaid Balance</Text>
                    <div>{item.UnpaidBalance ? `$ ${_commonService.formatNumberWithCommas(item.UnpaidBalance)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">If Pledged, to whom?</Text>
                    <div>{item.PledgeToWhome ? item.PledgeToWhome : "N/A"}</div>
                  </Col>
                </Row>
              </Card>
            ))}
          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseCashValueLifeInsurance}
        >
          <CollapsePanel
            key="4"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>Cash Value (Net of Policy Loans) Life Insurance</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails && financialStatementDataDetails.CashValueLifeInsuranceTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.CashValueLifeInsuranceTotal)}` : "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {cashValueLifeInsuranceDetails?.map((item) => (
              <Card
                key={item.Id}
                size="small"
                type="inner"
                // style={{ marginBottom: 16, borderRadius: 8 }}
                // bodyStyle={{ padding: 16 }}
                 className="mb30 card-section custom-section"
              >
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <Text type="secondary">Name of Company</Text>
                    <div>{item.NameOfCompany ? item.NameOfCompany : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Beneficiary</Text>
                    <div>{item.Beneficiary ? item.Beneficiary : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Owner</Text>
                    <div>{item.Owner ? item.Owner : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Loans</Text>
                    <div>{item.Loans ? `$ ${_commonService.formatNumberWithCommas(item.Loans)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Cash Value</Text>
                    <div>{item.CashValue ? `$ ${_commonService.formatNumberWithCommas(item.CashValue)}` : "N/A"}</div>
                  </Col>
                  <Col span={8}>
                    <Text type="secondary">Amount</Text>
                    <div>{item.Amount ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}` : "N/A"}</div>
                  </Col>
                </Row>
              </Card>
            ))}
          </CollapsePanel>
        </Collapse>

        <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography"><strong>Other Liquid Assets</strong></span>
          </div>
          <div class="ant-col">
            <span class="ant-typography"><strong>{financialStatementDataDetails.OtherLiquidAssetsTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.OtherLiquidAssetsTotal)}` : "N/A"}</strong></span>
          </div>
        </div>
        <ReviewCommentByApplicationIdAndSection  CommentSectionName="balancesheetasset" />
      </Card>
      <Card
        title={
          <Row justify="space-between" align="middle" className="balance-heading">
            <Text strong>
              <span role="img" aria-label="user" style={{ marginRight: 8 }}><TagsOutlined /></span>
              Balance Sheet - Total Assets
            </Text>
            <Text className="balance-price" align="middle">
              <span className="b-price"> {financialStatementDataDetails.AssetsTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.AssetsTotal)}`: "N/A"}</span>
              <EditOutlined onClick={onBalanceSheetTotalAssetsEditClick} style={{ color: "#595959", cursor: "pointer" }} />
            </Text>

          </Row>
        }       
        className="mb30 card-section custom-section"
      >
        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseOwnPersonalResidence}
        >
          <CollapsePanel
            key="5"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>RE Owned - Personal Residence (S) - Total</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails && financialStatementDataDetails.OwnPersonalResidenceTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.OwnPersonalResidenceTotal)}`: "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {

              ownPersonalResidenceDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  // style={{ marginBottom: 16, borderRadius: 8 }}
                  // bodyStyle={{ padding: 16 }}
                   className="mb30 card-section custom-section"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">Property & Location</Text>
                      <div>{item.PropertyAndLocation ? item.PropertyAndLocation : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Owner</Text>
                      <div>{item.Owner ? item.Owner : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Date Acquired</Text>
                      <div>{item.DateAcquired ? _commonService.convertToMMDDYYYY(new Date(item.DateAcquired)) : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Cost</Text>
                      <div>{item.Cost ? `$ ${_commonService.formatNumberWithCommas(item.Cost)}` : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Market Value</Text>
                      <div>
                        {item.MarketValue ? `$ ${_commonService.formatNumberWithCommas(item.MarketValue)}` : 'N/A'}
                      </div>
                    </Col>

                    <Col span={8}>
                      <Text type="secondary">Mortgagor</Text>
                      <div>{item.Mortgagor || 'N/A'}</div>
                    </Col>

                    <Col span={8}>
                      <Text type="secondary">Maturity Date</Text>
                      <div>
                        {item.Maturity ? _commonService.convertToMMDDYYYY(item.Maturity) : 'N/A'}
                      </div>
                    </Col>

                    <Col span={8}>
                      <Text type="secondary">Amount</Text>
                      <div>
                        {item.Amount ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}` : 'N/A'}
                      </div>
                    </Col>

                  </Row>
                </Card>
              ))
            }


          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseestedIntrestPension}
        >
          <CollapsePanel
            key="6"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>Vested Interest in Pension/Profit Share/Deferred Comp</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails.VestedIntrestPensionTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.VestedIntrestPensionTotal)}`:"N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              vestedIntrestPensionDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  // style={{ marginBottom: 16, borderRadius: 8 }}
                  // bodyStyle={{ padding: 16 }}
                   className="mb30 card-section custom-section"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">Name of Company</Text>
                      <div>{item.NameOfCompany || 'N/A'}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Owner</Text>
                      <div>{item.Owner || 'N/A'}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Beneficiary</Text>
                      <div>{item.Beneficiary || 'N/A'}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Payout Basis</Text>
                      <div>{item.PayoutBasis ? _commonService.formatNumberWithCommas(item.PayoutBasis) : 'N/A'}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Date Available</Text>
                      <div>
                        {item.AvailableDate
                          ? _commonService.convertToMMDDYYYY(item.AvailableDate)
                          : 'N/A'}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Amount</Text>
                      <div>
                        {item.Amount && item.Amount !== null && item.Amount !== undefined
                          ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}`
                          : 'N/A'}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }

          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapUnListedStocks}
        >
          <CollapsePanel
            key="7"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>Unlisted Stocks – Total Accounts and Notes Receivable</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails.UnListedStocksTotal ? `$ ${financialStatementDataDetails && _commonService.formatNumberWithCommas(financialStatementDataDetails.UnListedStocksTotal)}`:"N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              unListedStocksDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  // style={{ marginBottom: 16, borderRadius: 8 }}
                  // bodyStyle={{ padding: 16 }}
                   className="mb30 card-section custom-section"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">Description of Securities</Text>
                      <div>{item.DescriptionOfSecurity || 'N/A'}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Number of Shares Owned</Text>
                      <div>
                        {item.InNameOf !== null && item.InNameOf !== undefined
                          ? _commonService.formatNumberWithCommas(item.InNameOf)
                          : 'N/A'}
                      </div>
                    </Col>

                    <Col span={8}>
                      <Text type="secondary">Ownership</Text>
                      <div>
                        {item.OwenershipPercentage
                          ? `${item.OwenershipPercentage} %`
                          : 'N/A'}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Book Value</Text>
                      <div>
                        {item.BookValue
                          ? `$ ${_commonService.formatNumberWithCommas(item.BookValue)}`
                          : 'N/A'}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Book Value Amount</Text>
                      <div>
                        {item.BookValueAmount
                          ? `$ ${_commonService.formatNumberWithCommas(item.BookValueAmount)}`
                          : 'N/A'}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">If Pledged, To Whom?</Text>
                      <div>{item.PledgeToWhome || 'N/A'}</div>
                    </Col>
                  </Row>
                </Card>
              ))
            }



          </CollapsePanel>
        </Collapse>


        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapReInvestment}
        >
          <CollapsePanel
            key="8"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>RE Investments</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails.InvestmentTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.InvestmentTotal)}`:"N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              reInvestmentDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  // style={{ marginBottom: 16, borderRadius: 8 }}
                  // bodyStyle={{ padding: 16 }}
                   className="mb30 card-section custom-section"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">Property & Location</Text>
                      <div>{item.PropertyAndLocation || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Owner</Text>
                      <div>{item.Owner || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Date Acquired</Text>
                      <div>{item.DateAcquired ? _commonService.convertToMMDDYYYY(item.DateAcquired) : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Cost</Text>
                      <div>
                        {item.Cost && item.Cost != null
                          ? `$ ${_commonService.formatNumberWithCommas(item.Cost)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Market Value</Text>
                      <div>
                        {item.MarketValue && item.MarketValue != null
                          ? `$ ${_commonService.formatNumberWithCommas(item.MarketValue)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Mortgagor</Text>
                      <div>{item.Mortgagor || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date</Text>
                      <div>{item.Maturity ? _commonService.convertToMMDDYYYY(item.Maturity) : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Amount</Text>
                      <div>
                        {item.Amount && item.Amount != null
                          ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }



          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapgeneralAndLimitedPartenership}
        >
          <CollapsePanel
            key="9"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>General and/or Limited Partnership Interests</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails.GeneralAndLimitedPartenershipIntrestTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.GeneralAndLimitedPartenershipIntrestTotal)}`: "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              generalAndLimitedPartenershipDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  // style={{ marginBottom: 16, borderRadius: 8 }}
                  // bodyStyle={{ padding: 16 }}
                   className="mb30 card-section custom-section"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">Name of Partnership</Text>
                      <div>{item.NameOfPartenership ? item.NameOfPartenership : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Type of Investment</Text>
                      <div>{item.TypeOfInvestment ? item.TypeOfInvestment : "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Limited or General Partnership Interest</Text>
                      <div>{item.LimitedOrGeneral || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Amount Invested</Text>
                      <div>
                        {item.AmountInvested
                          ? `$ ${_commonService.formatNumberWithCommas(item.AmountInvested)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Fair Market Value of Partnership Interest</Text>
                      <div>
                        {item.FairMarketValue
                          ? `$ ${_commonService.formatNumberWithCommas(item.FairMarketValue)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }


          </CollapsePanel>
        </Collapse>
        <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography"><strong>IRA/Keogh Accounts</strong></span>
          </div>
          <div class="ant-col">
            <span class="ant-typography"><strong>{financialStatementDataDetails.IRAKeoghAccountsTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.IRAKeoghAccountsTotal)}`: "N/A"}</strong></span>
          </div>
        </div>
        <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography"><strong>Equity Interest in Business</strong></span>
          </div>
          <div class="ant-col">
            <span class="ant-typography"><strong>{financialStatementDataDetails.EquityInterestInBusinessTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.EquityInterestInBusinessTotal)}`: "N/A"}</strong></span>
          </div>
        </div>
        <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography"><strong>Personal Property</strong></span>
          </div>
          <div class="ant-col">
            <span class="ant-typography"><strong>{financialStatementDataDetails.PersonalPropertyTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.PersonalPropertyTotal)}`: "N/A"}</strong></span>
          </div>
        </div>
        <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography"><strong>Other Assets</strong></span>
          </div>
          <div class="ant-col">
            <span class="ant-typography"><strong>{financialStatementDataDetails.OtherAssetsTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.OtherAssetsTotal)}`: "N/A"}</strong></span>
          </div>
        </div>
  <ReviewCommentByApplicationIdAndSection  CommentSectionName="balancesheettotalasset" />
      </Card>

      <Card
        title={
          <Row justify="space-between" align="middle" className="balance-heading">
            <Text strong>
              <span role="img" aria-label="user" style={{ marginRight: 8 }}> <ScheduleOutlined /> </span>
              Balance Sheet - Total Liabilities
            </Text>

            <Text>
              <span className="b-price"> {financialStatementDataDetails.LiabilitiesTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.LiabilitiesTotal)}`: "N/A"}</span>
              <EditOutlined onClick={onBalanceSheetTotalLiabilitiesAssetsEditClick} style={{ color: "#595959", cursor: "pointer" }} />
            </Text>
          </Row>
        }       
        className="mb30 card-section custom-section"
      >
        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseNotesPayableBankSecured}
        >
          <CollapsePanel
            key="10"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>Notes Payable - Banks Secured</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails.NotesPayableBankSecuredTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.NotesPayableBankSecuredTotal)}`: "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              notesPayableBankSecuredDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  // style={{ marginBottom: 16, borderRadius: 8 }}
                  // bodyStyle={{ padding: 16 }}
                   className="mb30 card-section custom-section"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">To Whom?</Text>
                      <div>{item.ToWhom || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Payment Amount</Text>
                      <div>
                        {item.PaymentAmount
                          ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually</Text>
                      <div>{item.MonthlyQuaterlyAnnually || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Opening Date</Text>
                      <div>
                        {item.OpeningDate
                          ? _commonService.convertToMMDDYYYY(item.OpeningDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date</Text>
                      <div>
                        {item.MaturityDate
                          ? _commonService.convertToMMDDYYYY(item.MaturityDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Description of Collateral</Text>
                      <div>{item.DescriptionOfCollateral || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Secured)</Text>
                      <div>
                        {item.Balance_Secured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Unsecured)</Text>
                      <div>
                        {item.Balance_UnSecured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }

          </CollapsePanel>
        </Collapse>
        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseNotesPayableBankUnSecured}
        >
          <CollapsePanel
            key="11"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>Notes Payable - Banks Unsecured</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails.NotesPayableBankUnSecuredTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.NotesPayableBankUnSecuredTotal)}`:"N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              notesPayableBankUnSecuredDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  // style={{ marginBottom: 16, borderRadius: 8 }}
                  // bodyStyle={{ padding: 16 }}
                   className="mb30 card-section custom-section"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">To Whom?</Text>
                      <div>{item.ToWhom || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Payment Amount</Text>
                      <div>
                        {item.PaymentAmount
                          ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually</Text>
                      <div>{item.MonthlyQuaterlyAnnually || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Opening Date</Text>
                      <div>
                        {item.OpeningDate
                          ? _commonService.convertToMMDDYYYY(item.OpeningDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date</Text>
                      <div>
                        {item.MaturityDate
                          ? _commonService.convertToMMDDYYYY(item.MaturityDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Description of Collateral</Text>
                      <div>{item.DescriptionOfCollateral || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Secured)</Text>
                      <div>
                        {item.Balance_Secured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Unsecured)</Text>
                      <div>
                        {item.Balance_UnSecured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }

          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseChangeNotesPayableOther}
        >
          <CollapsePanel
            key="13"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>Notes Payable - Other</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails.NotesPayableOtherTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.NotesPayableOtherTotal)}`: "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              notesPayableOtherDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  // style={{ marginBottom: 16, borderRadius: 8 }}
                  // bodyStyle={{ padding: 16 }}
                   className="mb30 card-section custom-section"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">To Whom?</Text>
                      <div>{item.ToWhom || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Payment Amount</Text>
                      <div>
                        {item.PaymentAmount
                          ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually</Text>
                      <div>{item.MonthlyQuaterlyAnnually || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Opening Date</Text>
                      <div>
                        {item.OpeningDate
                          ? _commonService.convertToMMDDYYYY(item.OpeningDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date</Text>
                      <div>
                        {item.MaturityDate
                          ? _commonService.convertToMMDDYYYY(item.MaturityDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Description of Collateral</Text>
                      <div>{item.DescriptionOfCollateral || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Secured)</Text>
                      <div>
                        {item.Balance_Secured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Unsecured)</Text>
                      <div>
                        {item.Balance_UnSecured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }

          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseAccountsPayableChange}
        >
          <CollapsePanel
            key="12"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>Accounts Payable</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails && financialStatementDataDetails.AccountsPayableTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.AccountsPayableTotal)}`: "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              accountPayableDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  // style={{ marginBottom: 16, borderRadius: 8 }}
                  // bodyStyle={{ padding: 16 }}
                   className="mb30 card-section custom-section"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">To Whom?</Text>
                      <div>{item.ToWhom || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Payment Amount</Text>
                      <div>
                        {item.PaymentAmount
                          ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually</Text>
                      <div>{item.MonthlyQuaterlyAnnually || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Opening Date</Text>
                      <div>
                        {item.OpeningDate
                          ? _commonService.convertToMMDDYYYY(item.OpeningDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date</Text>
                      <div>
                        {item.MaturityDate
                          ? _commonService.convertToMMDDYYYY(item.MaturityDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Description of Collateral</Text>
                      <div>{item.DescriptionOfCollateral || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Secured)</Text>
                      <div>
                        {item.Balance_Secured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Unsecured)</Text>
                      <div>
                        {item.Balance_UnSecured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }

          </CollapsePanel>
        </Collapse>

        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseChangeCreditCardsBalance}
        >
          <CollapsePanel
            key="14"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>Credit Card Balances</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails.CreditCardsBalancesTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.CreditCardsBalancesTotal)}`: "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              creditCardBalanceDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  // style={{ marginBottom: 16, borderRadius: 8 }}
                  // bodyStyle={{ padding: 16 }}
                   className="mb30 card-section custom-section"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">To Whom?</Text>
                      <div>{item.ToWhom || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Payment Amount</Text>
                      <div>
                        {item.PaymentAmount
                          ? `$ ${_commonService.formatNumberWithCommas(item.PaymentAmount)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Monthly/Quarterly/Semi-Annual/Annually</Text>
                      <div>{item.MonthlyQuaterlyAnnually || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Opening Date</Text>
                      <div>
                        {item.OpeningDate
                          ? _commonService.convertToMMDDYYYY(item.OpeningDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date</Text>
                      <div>
                        {item.MaturityDate
                          ? _commonService.convertToMMDDYYYY(item.MaturityDate)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Description of Collateral</Text>
                      <div>{item.DescriptionOfCollateral || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Secured)</Text>
                      <div>
                        {item.Balance_Secured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_Secured)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Balance (Unsecured)</Text>
                      <div>
                        {item.Balance_UnSecured
                          ? `$ ${_commonService.formatNumberWithCommas(item.Balance_UnSecured)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }

          </CollapsePanel>
        </Collapse>


        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseChangeMortagagesDueWihtinOne}
        >
          <CollapsePanel
            key="15"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>Mortgages Due Within 1 Year</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails.MortgagesDueWithinOneYearTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.MortgagesDueWithinOneYearTotal)}`: "N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              mortgagesDueWithInOneDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  // style={{ marginBottom: 16, borderRadius: 8 }}
                  // bodyStyle={{ padding: 16 }}
                   className="mb30 card-section custom-section"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">Property & Location</Text>
                      <div>{item.PropertyAndLocation || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Owner</Text>
                      <div>{item.Owner || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Date Acquired</Text>
                      <div>
                        {item.DateAcquired
                          ? _commonService.convertToMMDDYYYY(item.DateAcquired)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Cost</Text>
                      <div>
                        {item.Cost
                          ? `$ ${_commonService.formatNumberWithCommas(item.Cost)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Market Value</Text>
                      <div>
                        {item.MarketValue
                          ? `$ ${_commonService.formatNumberWithCommas(item.MarketValue)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Mortgagor</Text>
                      <div>{item.Mortgagor || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date</Text>
                      <div>
                        {item.Maturity
                          ? _commonService.convertToMMDDYYYY(item.Maturity)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Amount</Text>
                      <div>
                        {item.Amount
                          ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }

          </CollapsePanel>
        </Collapse>


        <Collapse
          accordion
          expandIconPosition="end"
          ghost
          collapsible="icon"
          style={{ backgroundColor: "transparent" }}
          onChange={handleCollapseChangeMortagagesDueBeyondOne}
        >
          <CollapsePanel
            key="16"
            style={{ backgroundColor: "transparent" }}
            header={
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Text strong>Mortgages Due Beyond 1 Year</Text>
                </Col>
                <Col>
                  <Text strong>{financialStatementDataDetails.MortgagesDueBeyondOneYearTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.MortgagesDueBeyondOneYearTotal)}`:"N/A"}</Text>
                </Col>
              </Row>
            }
          >
            {
              mortgagesDueBeyondOneDetails?.map((item) => (
                <Card
                  key={item.Id}
                  size="small"
                  type="inner"
                  // style={{ marginBottom: 16, borderRadius: 8 }}
                  // bodyStyle={{ padding: 16 }}
                   className="mb30 card-section custom-section"
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text type="secondary">Property & Location</Text>
                      <div>{item.PropertyAndLocation || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Owner</Text>
                      <div>{item.Owner || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Date Acquired</Text>
                      <div>
                        {item.DateAcquired
                          ? _commonService.convertToMMDDYYYY(item.DateAcquired)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Cost</Text>
                      <div>
                        {item.Cost
                          ? `$ ${_commonService.formatNumberWithCommas(item.Cost)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Market Value</Text>
                      <div>
                        {item.MarketValue
                          ? `$ ${_commonService.formatNumberWithCommas(item.MarketValue)}`
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Mortgagor</Text>
                      <div>{item.Mortgagor || "N/A"}</div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Maturity Date</Text>
                      <div>
                        {item.Maturity
                          ? _commonService.convertToMMDDYYYY(item.Maturity)
                          : "N/A"}
                      </div>
                    </Col>
                    <Col span={8}>
                      <Text type="secondary">Amount</Text>
                      <div>
                        {item.Amount
                          ? `$ ${_commonService.formatNumberWithCommas(item.Amount)}`
                          : "N/A"}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            }

          </CollapsePanel>
        </Collapse>
        <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography"><strong>Unpaid Income Taxes</strong></span>
          </div>
          <div class="ant-col">
            <span class="ant-typography"><strong>{financialStatementDataDetails.UnpaidIncomeTaxesTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.UnpaidIncomeTaxesTotal)}` : "N/A"}</strong></span>
          </div>
        </div>
        <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography"><strong>Long Term Notes Payable</strong></span>
          </div>
          <div class="ant-col">
            <span class="ant-typography"><strong>{financialStatementDataDetails.Long_Term_Notes_Payable ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.Long_Term_Notes_Payable)}` : "N/A"}</strong></span>
          </div>
        </div>
        <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography"><strong>Deferred Tax Liabilities</strong></span>
          </div>
          <div class="ant-col">
            <span class="ant-typography"><strong>{financialStatementDataDetails.Deferred_Tax_Liabilities ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.Deferred_Tax_Liabilities)}` : "N/A"}</strong></span>
          </div>
        </div>
        <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography"><strong>Other Long Term Liabilities</strong></span>
          </div>
          <div class="ant-col">
            <span class="ant-typography"><strong>{financialStatementDataDetails.Other_Long_Term_Liabilities ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.Other_Long_Term_Liabilities)}` : "N/A"}</strong></span>
          </div>
        </div>
        <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography"><strong>Margin Accounts</strong></span>
          </div>
          <div class="ant-col">
            <span class="ant-typography"><strong>{financialStatementDataDetails.MarginAccountTotal ? `$ ${ _commonService.formatNumberWithCommas(financialStatementDataDetails.MarginAccountTotal)}`: "N/A"}</strong></span>
          </div>
        </div>
        <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography"><strong>Other Liabilities</strong></span>
          </div>
          <div class="ant-col">
            <span class="ant-typography"><strong>{financialStatementDataDetails.OtherLiabilitiesTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.OtherLiabilitiesTotal)}`: "N/A"}</strong></span>
          </div>
        </div>
        {/* <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography"><strong>Total Liabilities</strong></span>
          </div>
          <div class="ant-col">
            <span class="ant-typography"><strong>{financialStatementDataDetails.LiabilitiesTotal}</strong></span>
          </div>
        </div> */}
        <div class="ant-row ant-row-space-between ant-row-middle" style={{ padding: "12px 16px" }}>
          <div class="ant-col">
            <span class="ant-typography"><strong>Net Worth</strong></span>
          </div>
          <div class="ant-col">
            <span class="ant-typography"><strong>{financialStatementDataDetails.NetWorthTotal ? `$ ${_commonService.formatNumberWithCommas(financialStatementDataDetails.NetWorthTotal)}` : "N/A"}</strong></span>
          </div>
        </div>

         <ReviewCommentByApplicationIdAndSection  CommentSectionName="balancesheetliability" />
      </Card>

      <BalanceSheetQuestionnaireDashboard activeKey={activeKey} />

    </Spin>
  )
}
export default FinancialStatementTab;